import { Component, Input, OnInit } from '@angular/core';
import { EndpointService } from '@app/endpoint/endpoint.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TestCaseService } from '@app/testcase/testcase.service';
import { TableFilterPipe } from '@app/_pipes/table-filter.pipe';

@Component({
  selector: 'app-clone-across-testcase',
  templateUrl: './clone-across-testcase.component.html',
  styleUrls: ['./clone-across-testcase.component.less']
})
export class CloneAcrossTestcaseComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal, private toastr: ToastrService,
    private testCaseService: TestCaseService) { }

  @Input() validation: any;
  testCaseEndPointList: any;
  allSelected: boolean = false;
  filterString: string;
  ignore: boolean = false;

  ngOnInit() {
    this.getTestCaseEndpointList();
  }

  getTestCaseEndpointList(): void {
    this.testCaseService.getTestCaseEndPointList(this.validation.testCaseEndPoint.id).subscribe(data => {
      if (data.code == 200) {
        this.testCaseEndPointList = data.response.filter((testCaseEndPoint) => {
          return testCaseEndPoint.id != this.validation.testCaseEndPoint.id
        });
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  selectAll(event: any) {
    this.allSelected = event.target.checked;

    let list = this.testCaseEndPointList;

    if (this.filterString) {
      const filterPipe = new TableFilterPipe();
      list = filterPipe.transform(list, { testCaseName: this.filterString });
    }

    list.map((testCaseEndPoint: { isSelected: boolean; }) => { testCaseEndPoint.isSelected = this.allSelected });
  }

  onCheckboxChange(event: any, endPoint: any): void {
    endPoint.isSelected = event.target.checked;
    if (!event.target.checked)
      this.allSelected = false;
  }

  cloneAcrossTestCase(testCaseEndPointList: any) {
    let list = testCaseEndPointList;
    let selectedEndPoints: any = [];

    if (this.filterString) {
      const filterPipe = new TableFilterPipe();
      list = filterPipe.transform(list, { testCaseName: this.filterString });
    }

    selectedEndPoints = list.filter((testCaseEndPoint: { isSelected: any; }) => {
      if (testCaseEndPoint.isSelected) {
        delete testCaseEndPoint.isSelected;
        return testCaseEndPoint;
      }
    });

    if (selectedEndPoints.length == 0) {
      this.toastr.error("Please select atleast one TestCase-Endpoint");
      return;
    }

    this.testCaseService.cloneValidationAcrossTestCases(this.validation.id, selectedEndPoints, this.ignore).subscribe(data => {
      if (data.code == 200) {
        this.toastr.success(data.message);
        this.activeModal.close();
      } else {
        this.toastr.error(data.message);
      }
      this.allSelected = false;
    });
  }

}
